var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Sort by: "),_c('b-dropdown',{attrs:{"text":_vm.sortLabel,"right":"","variant":"link"}},_vm._l((_vm.options),function(item){return _c('b-dropdown-item',{key:item.label,attrs:{"to":{query: _vm.getQuery(item.value)},"active-class":"active","exact":""}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }